var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"action-groups"}},_vm._l((_vm.groups),function(group,key){return _c('action-group',{key:key,attrs:{"group":group},on:{"actionClick":_vm.onActionClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }